import React from 'react';
import { Check, Sparkles, Rocket, Calendar, ShieldCheck, Flame } from 'lucide-react';
import './PricingPage.css';
import CommonHeader from '../components/CommonHeader';
import Footer from '../components/Footer';

const PricingPage = () => {
  return (
    <div className="landing-wrapper">
      <CommonHeader />
      
      <main className="pricing-container">
        {/* HERO BANNER SECTION */}
        <div className="pricing-hero">
          <div className="pricing-badge">
            <Sparkles size={16} fill="currentColor" />
            <span>100% Free Access</span>
          </div>
          <h1>Simple, Transparent Pricing</h1>
          <p>Learn, play, and master your school curriculum. Start enjoying full core features today completely on us!</p>
        </div>

        {/* CURRENT LIVE PROMOTION BANNER */}
        <section className="current-free-banner">
          <div className="banner-content">
            <div className="banner-text">
              <h2><Flame size={24} className="banner-icon-fire" fill="currentColor" /> Early Bird Special</h2>
              <p>Knolup is currently completely **Free to Play** while we scale our question databases! Create an account today to lock in your legacy student progress metrics.</p>
            </div>
            <button className="btn-banner-action" onClick={() => window.location.href='/register'}>
              Get Started Free
            </button>
          </div>
        </section>

        {/* PRICING PLANS GRID */}
        <div className="pricing-grid">
          
          {/* PLAN 1: CURRENT LIVE FREE TIER */}
          <div className="price-card free-active">
            <div className="card-badge-status">Active Plan</div>
            <div className="price-card-header">
              <Rocket size={32} className="plan-icon-free" />
              <h3>Starter Explorer</h3>
              <p className="plan-desc">Perfect for students starting their academic adventure modules.</p>
              <div className="price-display">
                <span className="currency">$</span>
                <span className="amount">0</span>
                <span className="period">/ forever</span>
              </div>
            </div>
            <div className="price-card-features">
              <ul>
                <li><Check size={18} /> <span>All CBSE Class 6 Topics</span></li>
                <li><Check size={18} /> <span>Interactive Quiz Systems</span></li>
                <li><Check size={18} /> <span>Basic Badge Tracking</span></li>
                <li><Check size={18} /> <span>Standard Parental Reports</span></li>
              </ul>
            </div>
            <button className="btn-price-card" onClick={() => window.location.href='/register'}>
              Start Learning Now
            </button>
          </div>

          {/* PLAN 2: FUTURE MONTHLY MODULE */}
          <div className="price-card future-plan disabled-tier">
            <div className="card-badge-status coming-soon">Coming Soon</div>
            <div className="price-card-header">
              <Calendar size={32} className="plan-icon-future" />
              <h3>Premium Monthly</h3>
              <p className="plan-desc">For driven learners looking for deep core curriculum sprints.</p>
              <div className="price-display muted-price">
                <span className="amount-tbd">TBD</span>
                <span className="period">/ monthly</span>
              </div>
            </div>
            <div className="price-card-features">
              <ul>
                <li><Check size={18} /> <span>Advanced Math & History Datasets</span></li>
                <li><Check size={18} /> <span>Unlimited Printable Worksheets</span></li>
                <li><Check size={18} /> <span>Avatar Customization Goodies</span></li>
                <li><Check size={18} /> <span>Priority Support Chat Access</span></li>
              </ul>
            </div>
            <button className="btn-price-card" disabled>Coming Soon</button>
          </div>

          {/* PLAN 3: FUTURE ANNUAL BUNDLE */}
          <div className="price-card future-plan disabled-tier featured-future">
            <div className="card-badge-status coming-soon premium-label">Best Value</div>
            <div className="price-card-header">
              <ShieldCheck size={32} className="plan-icon-future-featured" />
              <h3>Academic Scholar</h3>
              <p className="plan-desc">Complete year-round study tracking companion layout.</p>
              <div className="price-display muted-price">
                <span className="amount-tbd">TBD</span>
                <span className="period">/ annually</span>
              </div>
            </div>
            <div className="price-card-features">
              <ul>
                <li><Check size={18} /> <span>Everything included in Monthly</span></li>
                <li><Check size={18} /> <span>Exclusive Annual Milestone Badges</span></li>
                <li><Check size={18} /> <span>Full Cumulative Analytics Export</span></li>
                <li><Check size={18} /> <span>Maximum Discount Pricing Tier</span></li>
              </ul>
            </div>
            <button className="btn-price-card" disabled>Coming Soon</button>
          </div>

        </div>

        {/* FUTURE WEEKLY PLAN QUICK NOTE HEADER */}
        <footer className="pricing-footer-note">
          <p>💡 <strong>Looking for short terms?</strong> We will also be launching flexible <strong>Weekly micro-passes</strong> alongside our standard subscription structures for quick exam preparation periods!</p>
        </footer>
      </main>

      <Footer />
    </div>
  );
};

export default PricingPage;